import { render } from "./BtnIcon.vue?vue&type=template&id=c72a4f94&scoped=true"
import script from "./BtnIcon.vue?vue&type=script&lang=js"
export * from "./BtnIcon.vue?vue&type=script&lang=js"

import "./BtnIcon.vue?vue&type=style&index=0&id=c72a4f94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c72a4f94"]])

export default __exports__